export default __webpack_public_path__ + "c0daf91fcf8a76974015c8ab10bfb0f4.png";